// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "events-admin." + {"395":"wc-register","908":"wc-event","916":"wc-participants"}[chunkId] + ".js";
};